import React from "react";

export const CalendarAppConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: "/activity-management/team-calendar",
      component: React.lazy(() => import("./CalendarApp"))
    }
  ]
};
